import firebase from "firebase/app";
import "firebase/auth";

export const auth = firebase.initializeApp({
    apiKey: "AIzaSyDOpCG69qGmQg1FAedckhJrpHAv2PZDJ4A",
    authDomain: "unichat-aba46.firebaseapp.com",
    projectId: "unichat-aba46",
    storageBucket: "unichat-aba46.appspot.com",
    messagingSenderId: "715925698060",
    appId: "1:715925698060:web:69f78250a7c4d5379fe029"
}).auth();